module.exports = __webpack_public_path__ + "static/media/Home-page-img1.6d08340a.png";